
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index854hq0DU0W6hAW0yFkUYkOY9aVXyrnK4JiXZ6HJAn_0Meta } from "/usr/src/nuxt-app/pages/index.vue?macro=true";
import { default as indexwnCmPX4eT9IGNYYWS4Ap0tdfanPxR_hZW_45eiEdytu9gMeta } from "/usr/src/nuxt-app/pages/voitures/[[filter]]/index.vue?macro=true";
import { default as indexLqPAEjF_1WZWp2kWI6pRFU1woDcM_tge5RR8UTR50HoMeta } from "/usr/src/nuxt-app/pages/voitures/[make]/[title]/[id]/index.vue?macro=true";
import { default as voitures7uCEl08YPS1xPDKTbG1QI5YAVxihy00QziEu0_45xL_45TIMeta } from "/usr/src/nuxt-app/pages/voitures.vue?macro=true";
import { default as homeK4FhpEpkz4d79zna8Mh_4aI2kCFAYetADuLp9KkWQwQMeta } from "/usr/src/nuxt-app/pages/dashboard/home.vue?macro=true";
import { default as itemsTOQnFSgJ_eNS5eKltXPJDpYaRByyGc00ulhYoRfsMfMMeta } from "/usr/src/nuxt-app/pages/dashboard/items.vue?macro=true";
import { default as offers_45whAzzlCo214QKPT8rWyxyeU_nZG6Thup_G74sq0_45J4Meta } from "/usr/src/nuxt-app/pages/dashboard/offers.vue?macro=true";
import { default as mot_de_passGP8OdJrHWn6iw04sWuXlVMUt6U5tJycTMlOtzhbxCfgMeta } from "/usr/src/nuxt-app/pages/dashboard/parameter/mot_de_pass.vue?macro=true";
import { default as notificationsHfC4D0lxAhNN8ytWhjXX3p8c_45wc5IxrZsTWk76_cCbMMeta } from "/usr/src/nuxt-app/pages/dashboard/parameter/notifications.vue?macro=true";
import { default as information_personnelK9eF2LGBOAkaWVvin7sxzj1Rc5De3B1FyLmh9Fgq_zUMeta } from "/usr/src/nuxt-app/pages/dashboard/parameter/information_personnel.vue?macro=true";
import { default as abonnement_et_transactionRId5CcgKT602aTQT9E8uqgkgEyLc0VN3_3iq14UvjKcMeta } from "/usr/src/nuxt-app/pages/dashboard/parameter/abonnement_et_transaction.vue?macro=true";
import { default as Informations_de_facturation6HogL2ILeJYv3ovr6kH4UtNGQ0fzaIdSuoxY47nWESgMeta } from "/usr/src/nuxt-app/pages/dashboard/parameter/Informations_de_facturation.vue?macro=true";
import { default as parameterzKyuUjk91ulLxjltjMgP1LrHX2Xu_XSd7_y7eqhJWncMeta } from "/usr/src/nuxt-app/pages/dashboard/parameter.vue?macro=true";
import { default as saveditemsSN_45Xk_45sKcnmkx5lU1xYSTH0RE16e0qbq76qV4uojNWUMeta } from "/usr/src/nuxt-app/pages/dashboard/saveditems.vue?macro=true";
import { default as _91_91id_93_93PhoD9ZGmXQyO0SfYFMZ6TY5E9sw6DHdgWK94cNNAtKQMeta } from "/usr/src/nuxt-app/pages/dashboard/inbox/[[id]].vue?macro=true";
import { default as savedsearchestVmbxALCqr3HruvjPmrVeiH7Fohw8szCxsMfSXzCl6MMeta } from "/usr/src/nuxt-app/pages/dashboard/savedsearches.vue?macro=true";
import { default as dashboardysFg2c14glSMmI2Z1PKXpgbvzt9Ac8nkytctW1D0rdYMeta } from "/usr/src/nuxt-app/pages/dashboard.vue?macro=true";
import { default as builder1wkpvuZiNJBSA_45_AUxQrfXZ2IFufo1yCwd5EheUjyJIMeta } from "/usr/src/nuxt-app/pages/marketplace/builder.vue?macro=true";
import { default as success2SdrwwfM_Ru5tuWRJuj0ekGcqxzoOOtGfQzgXMbif_45QMeta } from "/usr/src/nuxt-app/pages/marketplace/success.vue?macro=true";
import { default as creationgveCt_T7Q2CDxYo6lQ8fxgOa3xJARDihFDne5DVNyLoMeta } from "/usr/src/nuxt-app/pages/marketplace/creation.vue?macro=true";
import { default as index84_45nxBLi0Rm5fQPEKBIdaQWHqWTgAJKCzeE48O_45ObzIMeta } from "/usr/src/nuxt-app/pages/marketplace/[name]/index.vue?macro=true";
import { default as _91name_9310WrU4iGGFb4Fq130edjQlUgX95SigWm5e4Xf1PftjcMeta } from "/usr/src/nuxt-app/pages/marketplace/preview/[name].vue?macro=true";
import { default as marketplace9OnRXJ1V6_WLYuxw2O67WYE5R76YsFbWRaNH87_45CPcQMeta } from "/usr/src/nuxt-app/pages/marketplace.vue?macro=true";
import { default as index0ei9_458kdysfwYk0AzvMERU783zuWp2ciyhcaPBpA7fIMeta } from "/usr/src/nuxt-app/pages/listing-form/index.vue?macro=true";
import { default as indexren6V9PsYU24aR_YHWPI8wV7rPdc59Et6p757DG9LXAMeta } from "/usr/src/nuxt-app/pages/listing-form/vehicle-data/[[edit]]/index.vue?macro=true";
import { default as listing_45form4z_oSkfEb2N9XCJW1VXx_45DBSbSAn4ObvmBHnOReqHK4Meta } from "/usr/src/nuxt-app/pages/listing-form.vue?macro=true";
import { default as loginw2moX257N_45Bwf6B4QC12Fc5Uo1SCx0zXtkD4YRkkQFoMeta } from "/usr/src/nuxt-app/pages/authentication/login.vue?macro=true";
import { default as signupRr9_8wPke6booGmdFRfNgulPwuowm3WXtp2gyn0nO8IMeta } from "/usr/src/nuxt-app/pages/authentication/signup.vue?macro=true";
import { default as forgot_45password73Rh1MMOKOcH5qrK6GJVWk9_OThk9axNiSMA2fanIBoMeta } from "/usr/src/nuxt-app/pages/authentication/forgot-password.vue?macro=true";
import { default as index95KFczmxCjmph3M3wC_45QEdHJn_45VbVIcyhtSdil7JYoUMeta } from "/usr/src/nuxt-app/pages/authentication/new-password/index.vue?macro=true";
import { default as indexZtsdRxOIkuMNz8A07DySz8C3ZVGMJAkalMx6Yd7wlmUMeta } from "/usr/src/nuxt-app/pages/authentication/verification/index.vue?macro=true";
import { default as successrAvCejn_45NenLpyiMxeyOZBjg_fopp860T6Oc7g9Ot_oMeta } from "/usr/src/nuxt-app/pages/authentication/new-password/success.vue?macro=true";
import { default as activate4d10ErFmxA0iEujJr2Ns3kFAKNG6H1ADhVR03uUXrgsMeta } from "/usr/src/nuxt-app/pages/authentication/verification/activate.vue?macro=true";
import { default as authenticationJ_45hve8lvokrvinX2MMpoxeGcNKoulknS_459z7TeiEZB8Meta } from "/usr/src/nuxt-app/pages/authentication.vue?macro=true";
import { default as contactez_45nousxwf_45qDS_45UrMuv_458gLJGxaUX45Q2O2KqFXJB_KqsISA8Meta } from "/usr/src/nuxt-app/pages/contactez-nous.vue?macro=true";
import { default as region_45voituredyK3fGS9yOMAFP6E_P75d5zeLKpbk83dJOkXfD57r1wMeta } from "/usr/src/nuxt-app/pages/region-voiture.vue?macro=true";
import { default as vendre_45voitureJplC0vNMQxOrCJbUBQW8vTu9y_459CSAJ0UQAlYdDQsAIMeta } from "/usr/src/nuxt-app/pages/vendre-voiture.vue?macro=true";
import { default as marques_45voitureShC6WN96y4iaYFwBFLBNIg3I0kw_bqId53AG4ssIYEkMeta } from "/usr/src/nuxt-app/pages/marques-voiture.vue?macro=true";
import { default as successFWTryp5ETOE1NPeXy5iZeiMhnXU4g88N1da5pXFV8d8Meta } from "/usr/src/nuxt-app/pages/Payment/success.vue?macro=true";
import { default as declinedQQK_45yscnj_NNnN9oXM1RWRdA5avOQ28h_45xkCVd_45_4lsMeta } from "/usr/src/nuxt-app/pages/Payment/declined.vue?macro=true";
import { default as conditions_45d_45utilisationpR7mhuQg3UPSj29OO7lwTc_451wTZ27PMZK_45TqlGWEijoMeta } from "/usr/src/nuxt-app/pages/conditions-d-utilisation.vue?macro=true";
import { default as politique_45de_45confidentialite77JMyMio4V_qSE1OjjW4KO0IkzunzKaLjOZe1GgV1QgMeta } from "/usr/src/nuxt-app/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexMFCqvUyxCv0DQXnm1ehcnc6mHVkToAmXbdwD5SgnA4MMeta } from "/usr/src/nuxt-app/pages/unsubscribe/ktm9sd0fggz5q/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index854hq0DU0W6hAW0yFkUYkOY9aVXyrnK4JiXZ6HJAn_0Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/index.vue")
  },
  {
    name: "voitures",
    path: "/voitures",
    meta: voitures7uCEl08YPS1xPDKTbG1QI5YAVxihy00QziEu0_45xL_45TIMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/voitures.vue"),
    children: [
  {
    name: "voitures-filter",
    path: ":filter?",
    meta: { ...(indexwnCmPX4eT9IGNYYWS4Ap0tdfanPxR_hZW_45eiEdytu9gMeta || {}), ...{"middleware":"redirect-invalid-filters"} },
    component: () => import("/usr/src/nuxt-app/pages/voitures/[[filter]]/index.vue")
  },
  {
    name: "voitures-make-title-id",
    path: ":make()/:title()/:id()",
    meta: indexLqPAEjF_1WZWp2kWI6pRFU1woDcM_tge5RR8UTR50HoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/voitures/[make]/[title]/[id]/index.vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardysFg2c14glSMmI2Z1PKXpgbvzt9Ac8nkytctW1D0rdYMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/dashboard.vue"),
    children: [
  {
    name: "dashboard-home",
    path: "home",
    component: () => import("/usr/src/nuxt-app/pages/dashboard/home.vue")
  },
  {
    name: "dashboard-items",
    path: "items",
    meta: itemsTOQnFSgJ_eNS5eKltXPJDpYaRByyGc00ulhYoRfsMfMMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/dashboard/items.vue")
  },
  {
    name: "dashboard-offers",
    path: "offers",
    meta: offers_45whAzzlCo214QKPT8rWyxyeU_nZG6Thup_G74sq0_45J4Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/dashboard/offers.vue")
  },
  {
    name: "dashboard-parameter",
    path: "parameter",
    meta: parameterzKyuUjk91ulLxjltjMgP1LrHX2Xu_XSd7_y7eqhJWncMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/dashboard/parameter.vue"),
    children: [
  {
    name: "dashboard-parameter-mot_de_pass",
    path: "mot_de_pass",
    meta: mot_de_passGP8OdJrHWn6iw04sWuXlVMUt6U5tJycTMlOtzhbxCfgMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/dashboard/parameter/mot_de_pass.vue")
  },
  {
    name: "dashboard-parameter-notifications",
    path: "notifications",
    component: () => import("/usr/src/nuxt-app/pages/dashboard/parameter/notifications.vue")
  },
  {
    name: "dashboard-parameter-information_personnel",
    path: "information_personnel",
    component: () => import("/usr/src/nuxt-app/pages/dashboard/parameter/information_personnel.vue")
  },
  {
    name: "dashboard-parameter-abonnement_et_transaction",
    path: "abonnement_et_transaction",
    component: () => import("/usr/src/nuxt-app/pages/dashboard/parameter/abonnement_et_transaction.vue")
  },
  {
    name: "dashboard-parameter-Informations_de_facturation",
    path: "Informations_de_facturation",
    component: () => import("/usr/src/nuxt-app/pages/dashboard/parameter/Informations_de_facturation.vue")
  }
]
  },
  {
    name: "dashboard-saveditems",
    path: "saveditems",
    meta: saveditemsSN_45Xk_45sKcnmkx5lU1xYSTH0RE16e0qbq76qV4uojNWUMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/dashboard/saveditems.vue")
  },
  {
    name: "dashboard-inbox-id",
    path: "inbox/:id?",
    component: () => import("/usr/src/nuxt-app/pages/dashboard/inbox/[[id]].vue")
  },
  {
    name: "dashboard-savedsearches",
    path: "savedsearches",
    meta: savedsearchestVmbxALCqr3HruvjPmrVeiH7Fohw8szCxsMfSXzCl6MMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/dashboard/savedsearches.vue")
  }
]
  },
  {
    name: "marketplace",
    path: "/marketplace",
    meta: marketplace9OnRXJ1V6_WLYuxw2O67WYE5R76YsFbWRaNH87_45CPcQMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace-builder",
    path: "builder",
    component: () => import("/usr/src/nuxt-app/pages/marketplace/builder.vue")
  },
  {
    name: "marketplace-success",
    path: "success",
    component: () => import("/usr/src/nuxt-app/pages/marketplace/success.vue")
  },
  {
    name: "marketplace-creation",
    path: "creation",
    meta: creationgveCt_T7Q2CDxYo6lQ8fxgOa3xJARDihFDne5DVNyLoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/marketplace/creation.vue")
  },
  {
    name: "marketplace-name",
    path: ":name()",
    meta: index84_45nxBLi0Rm5fQPEKBIdaQWHqWTgAJKCzeE48O_45ObzIMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/marketplace/[name]/index.vue")
  },
  {
    name: "marketplace-preview-name",
    path: "preview/:name()",
    component: () => import("/usr/src/nuxt-app/pages/marketplace/preview/[name].vue")
  }
]
  },
  {
    name: listing_45form4z_oSkfEb2N9XCJW1VXx_45DBSbSAn4ObvmBHnOReqHK4Meta?.name,
    path: "/listing-form",
    component: () => import("/usr/src/nuxt-app/pages/listing-form.vue"),
    children: [
  {
    name: "listing-form",
    path: "",
    meta: {"middleware":["announcement-validation"]},
    component: () => import("/usr/src/nuxt-app/pages/listing-form/index.vue")
  },
  {
    name: "listing-form-vehicle-data-edit",
    path: "vehicle-data/:edit?",
    meta: {"middleware":["announcement-validation"]},
    component: () => import("/usr/src/nuxt-app/pages/listing-form/vehicle-data/[[edit]]/index.vue")
  }
]
  },
  {
    name: "authentication",
    path: "/authentication",
    meta: authenticationJ_45hve8lvokrvinX2MMpoxeGcNKoulknS_459z7TeiEZB8Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/authentication.vue"),
    children: [
  {
    name: "authentication-login",
    path: "login",
    component: () => import("/usr/src/nuxt-app/pages/authentication/login.vue")
  },
  {
    name: "authentication-signup",
    path: "signup",
    component: () => import("/usr/src/nuxt-app/pages/authentication/signup.vue")
  },
  {
    name: "authentication-forgot-password",
    path: "forgot-password",
    component: () => import("/usr/src/nuxt-app/pages/authentication/forgot-password.vue")
  },
  {
    name: "authentication-new-password",
    path: "new-password",
    component: () => import("/usr/src/nuxt-app/pages/authentication/new-password/index.vue")
  },
  {
    name: "authentication-verification",
    path: "verification",
    component: () => import("/usr/src/nuxt-app/pages/authentication/verification/index.vue")
  },
  {
    name: "authentication-new-password-success",
    path: "new-password/success",
    component: () => import("/usr/src/nuxt-app/pages/authentication/new-password/success.vue")
  },
  {
    name: "authentication-verification-activate",
    path: "verification/activate",
    component: () => import("/usr/src/nuxt-app/pages/authentication/verification/activate.vue")
  }
]
  },
  {
    name: "contactez-nous",
    path: "/contactez-nous",
    meta: contactez_45nousxwf_45qDS_45UrMuv_458gLJGxaUX45Q2O2KqFXJB_KqsISA8Meta || {},
    component: () => import("/usr/src/nuxt-app/pages/contactez-nous.vue")
  },
  {
    name: "region-voiture",
    path: "/region-voiture",
    meta: region_45voituredyK3fGS9yOMAFP6E_P75d5zeLKpbk83dJOkXfD57r1wMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/region-voiture.vue")
  },
  {
    name: "vendre-voiture",
    path: "/vendre-voiture",
    meta: vendre_45voitureJplC0vNMQxOrCJbUBQW8vTu9y_459CSAJ0UQAlYdDQsAIMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/vendre-voiture.vue")
  },
  {
    name: "marques-voiture",
    path: "/marques-voiture",
    meta: marques_45voitureShC6WN96y4iaYFwBFLBNIg3I0kw_bqId53AG4ssIYEkMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/marques-voiture.vue")
  },
  {
    name: "Payment-success",
    path: "/Payment/success",
    meta: {"middleware":["payment-validation"]},
    component: () => import("/usr/src/nuxt-app/pages/Payment/success.vue")
  },
  {
    name: "Payment-declined",
    path: "/Payment/declined",
    meta: {"middleware":["payment-validation"]},
    component: () => import("/usr/src/nuxt-app/pages/Payment/declined.vue")
  },
  {
    name: "conditions-d-utilisation",
    path: "/conditions-d-utilisation",
    meta: conditions_45d_45utilisationpR7mhuQg3UPSj29OO7lwTc_451wTZ27PMZK_45TqlGWEijoMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/conditions-d-utilisation.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    meta: politique_45de_45confidentialite77JMyMio4V_qSE1OjjW4KO0IkzunzKaLjOZe1GgV1QgMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/politique-de-confidentialite.vue")
  },
  {
    name: "unsubscribe-ktm9sd0fggz5q",
    path: "/unsubscribe/ktm9sd0fggz5q",
    meta: indexMFCqvUyxCv0DQXnm1ehcnc6mHVkToAmXbdwD5SgnA4MMeta || {},
    component: () => import("/usr/src/nuxt-app/pages/unsubscribe/ktm9sd0fggz5q/index.vue")
  }
]